import { makeActionCreator } from '../../../config/store/utils';
import { addFuel, getFuel } from '../../../services/monitoringService';

export const GET_FUEL = 'GET_FUEL';
export const GET_FUEL_ERROR = 'GET_FUEL_ERROR';
export const GET_FUEL_SUCCESS = 'GET_FUEL_SUCCESS';

export const onGetFuel = makeActionCreator(GET_FUEL);
export const onGetFuelError = makeActionCreator(GET_FUEL_ERROR, 'payload');
export const onGetFuelSuccess = makeActionCreator(GET_FUEL_SUCCESS, 'payload');

export const onGetFuelThunk = patent => async dispatch => {
  dispatch(onGetFuel());
  try {
    const { data } = await getFuel(patent);
    const parsed = typeof data === 'string' ? JSON.parse(data) : data;
    const eventos = (parsed.eventos ?? []).map(e => ({
      ...e,
      evento_carga_id: e.evento_carga_id ?? '-',
    }));
    return dispatch(
      onGetFuelSuccess({
        patent,
        eventos,
        combustibleRemanente: parsed.combustible_remanente ?? 0,
      })
    );
  } catch (error) {
    return dispatch(onGetFuelError({ error }));
  }
};

export const ADD_FUEL = 'ADD_FUEL';
export const ADD_FUEL_ERROR = 'ADD_FUEL_ERROR';
export const ADD_FUEL_SUCCESS = 'ADD_FUEL_SUCCESS';

export const onAddFuel = makeActionCreator(ADD_FUEL);
export const onAddFuelError = makeActionCreator(ADD_FUEL_ERROR, 'payload');
export const onAddFuelSuccess = makeActionCreator(ADD_FUEL_SUCCESS, 'payload');

export const onAddFuelThunk = (
  volumenTotal,
  patent,
  deviceId
) => async dispatch => {
  dispatch(onAddFuel());
  try {
    const { data } = await addFuel({
      volumen_total: volumenTotal,
      patent,
      device_id: deviceId,
    });
    const parsed = typeof data === 'string' ? JSON.parse(data) : data;
    return dispatch(
      onAddFuelSuccess({
        patent,
        volumenAgregado: parsed.volumen_agregado,
        combustibleRemanente: parsed.combustible_remanente,
      })
    );
  } catch (error) {
    return dispatch(onAddFuelError({ error }));
  }
};
